<template>
  <div>

    <t-form-card title="Produto">


      <t-page-form-upload
          :type-image="typeImage"
          :path="path" :primaryKeyColumn="primaryKeyColumn" :foreign-key-column="foreignKeyColumn"
          :primary-key="form.productFileId" :foreign-key="form.productId"
          :items="items" :user-auth="userAuth" :status="status"
          :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
          @onSubmit="onSubmit" @itemDownload="onItemFileDownload" @onItemDelete="onItemDeleteDefault"
          @onUploadComplete="onUploadComplete" @onRequestList="getList">

      </t-page-form-upload>

    </t-form-card>

    <t-form-card title="Modelo" v-if="modelId > 0">

      <t-msg info>{{ typeImage ? 'Imagens' : 'Arquivos' }} do modelo: <b>{{ model.modelCodeLabel }} - {{
          model.name
        }}</b> relacionado a
        este Produto, caso desejar alterar acesse: Produtos > <a
            :href="getLinkModel()" target="_blank">Modelos</a>
      </t-msg>

      <ModelFile other-entity :type-image="typeImage" :foreign-key="modelId"/>

    </t-form-card>

  </div>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin";
import pageFormUploadMixin from "@/mixins/page/pageFormUploadMixin";
import tPageFormUpload from "@/components/template/page/t-page-form-upload";
import ModelFile from "@/views/modules/product/ModelFile";
import ModelService from "@/services/modules/product/Model.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin, pageFormUploadMixin],
  components: {tPageFormUpload, ModelFile},
  name: 'ProductFile',
  data() {
    return {
      path: "product/item-file", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "productFileId",
      foreignKeyColumn: "productId", //Utilizar quando usar Tabs com outros componentes
      type: "D", //Tipo padrão de producto de envio de arquivos poderá ser I ou D
      form: {
        productId: this.foreignKey,
        productFileId: 0,
        orderList: 0,
        type: "",
        fileEntity: {
          nameOriginal: "",
          nameSave: "",
          sizeKb: 0,
          extension: "",
        }
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      model: {}
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    modelId: Number,
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      this.getModel(this.modelId)

      this.mountedPrepareFormUploadDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.productFileId)

    },

    mountedList() {

      // Manipulação da listagem após carregando
      //--------------------------------------

      //--------------------------------------
      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    getLinkModel(){

      let path =  '/product/model/'+this.model.modelNumber+'#'
      path += this.typeImage ? 'image' : 'file'
      return path

    },

    async getModel(modelId) {

      if(modelId > 0){

        await ModelService.getForceReadById(modelId).then(model => {
          this.model = model
        }).catch(error =>
            this.responseError(error)
        )

      }

    }
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
  watch: {

    modelId(v) {
      this.getModel(v)
    }

  }
}
</script>
